import { mapToCamelCase, mapToSnakeCase } from '@consigli/utils';
import { z } from 'zod';
import { fileSchema } from './file';
import { Language } from './language';
import { getPaginationResponseSchema } from './pagination';
import { projectSchema } from './project';
export var BuildingPackageType;
(function (BuildingPackageType) {
    BuildingPackageType["CEILING_GRID"] = "CEILING_GRID";
    BuildingPackageType["LOAD_CALCULATION"] = "LOAD_CALCULATION";
    BuildingPackageType["WASTEWATER_TREATMENT"] = "WASTEWATER_TREATMENT";
})(BuildingPackageType || (BuildingPackageType = {}));
export const BuildingPackageTypeLabels = {
    [BuildingPackageType.CEILING_GRID]: 'Ceiling Grid',
    [BuildingPackageType.LOAD_CALCULATION]: 'Load Calculation',
    [BuildingPackageType.WASTEWATER_TREATMENT]: 'Wastewater Treatment',
};
export var BuildingPackageWorkflowStep;
(function (BuildingPackageWorkflowStep) {
    // Retained for parsing packages created before the requirements workflow was retired.
    BuildingPackageWorkflowStep["PROCESSING_SPEC_REQUIREMENTS_STEP"] = "PROCESSING_SPEC_REQUIREMENTS_STEP";
    BuildingPackageWorkflowStep["USER_REVIEW_SPEC_REQUIREMENTS_STEP"] = "USER_REVIEW_SPEC_REQUIREMENTS_STEP";
    BuildingPackageWorkflowStep["PROCESSING_LOAD_CALCULATION_STEP"] = "PROCESSING_LOAD_CALCULATION_STEP";
    BuildingPackageWorkflowStep["PUBLISHED_LOAD_CALCULATION_STEP"] = "PUBLISHED_LOAD_CALCULATION_STEP";
})(BuildingPackageWorkflowStep || (BuildingPackageWorkflowStep = {}));
export const buildingPackageSchema = z
    .object({
    id: z.string().uuid(),
    project_id: projectSchema.innerType().shape.id,
    name: z.string().min(1),
    error_message: z.array(z.string()).optional(),
    warning_message: z.array(z.string()).optional(),
    health_check: z.boolean().nullish(),
    updated_at: z.string(),
    created_at: z.string(),
    created_by: z.string().uuid().nullable(),
    type: z.nativeEnum(BuildingPackageType),
    workflow_step: z.nativeEnum(BuildingPackageWorkflowStep).nullable(),
    is_hidden: z.boolean(),
})
    .strict()
    .transform(mapToCamelCase);
export const buildingPackagesSchema = z.array(buildingPackageSchema).transform(mapToCamelCase);
export const getBuildingPackagesResponseSchema = getPaginationResponseSchema(buildingPackageSchema);
export const createBuildingPackageRequestSchema = buildingPackageSchema
    .innerType()
    .pick({
    name: true,
})
    .merge(z.object({
    file_ids: z.array(fileSchema.innerType().shape.id),
    type: z.nativeEnum(BuildingPackageType).optional(),
    language: z.nativeEnum(Language).optional(),
    workflow_step: z.nativeEnum(BuildingPackageWorkflowStep).optional(),
}))
    .strict()
    .transform(mapToSnakeCase);
export const createBuildingPackageResponseSchema = buildingPackageSchema;
export const updateBuildingPackageRequestSchema = z
    .object({
    workflow_step: z.nativeEnum(BuildingPackageWorkflowStep),
})
    .partial()
    .strict()
    .transform(mapToSnakeCase);
export const updateBuildingPackageResponseSchema = buildingPackageSchema;
export const getBuildingPackageFilesRequestSchema = z
    .object({
    project_id: z.number().int(),
    building_package_id: z.string().uuid(),
    page: z.union([z.number().int(), z.literal('all')]),
    page_size: z.number().int().nullish(),
    search: z.string().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getBuildingPackageFilesResponseSchema = getPaginationResponseSchema(fileSchema);
export const getBuildingPackagesRequestSchema = z
    .object({
    project_id: z.number().int(),
    type: z.nativeEnum(BuildingPackageType).optional(),
    page: z.union([z.number().int(), z.literal('all')]),
    page_size: z.number().int().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
